"use strict";

var _applyMiddleware = require("./applyMiddleware");

var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);

var _reducerDynamic = require("./reducerDynamic");

var _reducerDynamic2 = _interopRequireDefault(_reducerDynamic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
    applyMiddleware: _applyMiddleware2.default,
    reducerDynamic: _reducerDynamic2.default
};


//////////////////
// WEBPACK FOOTER
// ./packages/bone-web@0.2/node_modules/_@bone_redux-dynamic@0.1.5@@bone/redux-dynamic/lib/index.js
// module id = 988
// module chunks = 4